import React, { createContext, useContext, useState } from 'react';

export interface CommandCenterStats {
  meCount: number;
  aiCount: number;
  doneCount: number;
  overdueCount: number;
}

interface CommandCenterStatsContextValue {
  stats: CommandCenterStats;
  setStats: (stats: CommandCenterStats) => void;
}

const CommandCenterStatsContext = createContext<CommandCenterStatsContextValue>({
  stats: { meCount: 0, aiCount: 0, doneCount: 0, overdueCount: 0 },
  setStats: () => {},
});

export const CommandCenterStatsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [stats, setStats] = useState<CommandCenterStats>({
    meCount: 0, aiCount: 0, doneCount: 0, overdueCount: 0,
  });
  return (
    <CommandCenterStatsContext.Provider value={{ stats, setStats }}>
      {children}
    </CommandCenterStatsContext.Provider>
  );
};

export const useCommandCenterStats = () => useContext(CommandCenterStatsContext);
